export default __webpack_public_path__ + "static/media/level-logo.3b65774f.svg";